export default "__VITE_ASSET__BwuqyTuV__"